import { Col, Container, Row } from "react-bootstrap"

const NotFound = () => {
  return (
    <>
      <Container>
        <Row>
          <Col md={12} className="text-center">
            <h1 className="hover-underline">Page Not Found</h1>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default NotFound;